import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as monthlyIncomeState from '../employee-detail.reducer';
import * as monthlyIncomeReducer from '../reducers/monthly-income.reducer';

export const getMonthlyIncome = createSelector(monthlyIncomeState.getMonthlyIncomeState, monthlyIncomeReducer.getMonthlyIncome);
